import { isProductionDomain, isSandboxDomain, isStagingDomain } from './domain';
import { runningServerSide } from './running';

export const getRuntimeEnvironment = () => {
  if (runningServerSide()) {
    return process.env.RUNTIME_ENV;
  } else {
    if (isStagingDomain()) return 'staging';
    if (isSandboxDomain()) return 'sandbox';
    if (['localhost', 'local.benzinga.com'].includes(window.location.hostname)) return 'development';
    if (isProductionDomain()) return 'production';
    return 'production';
  }
};
